import { SearchIcon } from '@cleartax/wg-library-icons';
import { ISearch } from '../index.component';
export const SearchOpenClose: React.FC<ISearch> = ({ open, closeCB }) => {
  return (
    <div className="h-full cursor-pointer flex items-center text-grey-400 font-medium pt-1">
      {open ? (
        <button
          onClick={() => (closeCB ? closeCB() : null)}
          className={`icon-arrow_back text-grey-500 text-s-20 font-semibold`}
        ></button>
      ) : (
        <SearchIcon className="ml-2" />
      )}
    </div>
  );
};
